import React, { useState } from 'react';
import { toast } from 'react-toastify';
import SideDrawer from '../../../organisms/SideDrawer';
import communicationApi from '../../../../services/communicationApi';
import { Group } from '../../../../types/communication';
import VariableTextField from '../composition/shared/VariableTextField';
import ToogleSwitch from '../../../atoms/ToogleSwitch';

interface NewGroupDrawerProps {
    open: boolean;
    onClose: () => void;
    onCreated: (group: Group) => void;
}

const NewGroupDrawer: React.FC<NewGroupDrawerProps> = ({ open, onClose, onCreated }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [isDefault, setIsDefault] = useState(false);
    const [error, setError] = useState<string | undefined>();
    const [saving, setSaving] = useState(false);

    const close = () => {
        setName('');
        setDescription('');
        setIsDefault(false);
        setError(undefined);
        onClose();
    };

    const create = async () => {
        if (!name.trim()) {
            setError('Obrigatório');
            return;
        }
        setSaving(true);
        try {
            const group = await communicationApi.createGroup({
                name,
                description,
                defaultForNewContactPoints: isDefault,
            });
            toast.success('Grupo criado. Agora adicione as pessoas.');
            close();
            onCreated(group);
        } catch (e) {
            setError(e instanceof Error ? e.message : 'Falha ao criar grupo.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <SideDrawer
            open={open}
            title="Novo grupo"
            subtitle="Grupos definem quem pode operar cada composição de mensagem."
            onClose={close}
            headerActions={
                <button
                    type="button"
                    onClick={create}
                    disabled={saving}
                    className="px-4 py-2 rounded-md text-sm bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
                >
                    {saving ? 'Salvando...' : 'Salvar'}
                </button>
            }
        >
            <div className="flex flex-col gap-4">
                <VariableTextField
                    id="new-group-name"
                    label="Nome do grupo"
                    value={name}
                    maxLength={80}
                    error={error}
                    onChange={(value) => {
                        setName(value);
                        setError(undefined);
                    }}
                />
                <VariableTextField
                    id="new-group-description"
                    label="Descrição"
                    value={description}
                    multiline
                    rows={3}
                    maxLength={240}
                    onChange={setDescription}
                />
                <div className="flex items-center justify-between rounded-lg border border-gray-200 dark:border-slate-700 px-3 py-2">
                    <div className="pr-3">
                        <div className="text-sm text-gray-800 dark:text-gray-100">Padrão para novos pontos de contato</div>
                        <div className="text-[11px] text-gray-400">
                            Novos contatos nascem elegíveis a este grupo automaticamente.
                        </div>
                    </div>
                    <ToogleSwitch checked={isDefault} onChange={setIsDefault} />
                </div>
            </div>
        </SideDrawer>
    );
};

export default NewGroupDrawer;
